(function () {
  'use strict';

  const popup = document.getElementById('mm-lead-popup');

  if (!popup) return;

  const steps = popup.querySelectorAll('.mm-step');
  const progressBar = popup.querySelector('#mm-progress-bar');

  let popupOpened = false;

  const state = {
    gender: '',
    trimester: '',
    shoppingFor: '',
    currentStep: '1'
  };

  /* =========================================
     STEP MANAGEMENT
     ========================================= */

  function showStep(stepName) {
    steps.forEach(function (step) {
      step.classList.remove('is-active');
    });

    const target = popup.querySelector(
      '.mm-step[data-step="' + stepName + '"]'
    );

    if (!target) return;

    target.classList.add('is-active');

    state.currentStep = stepName;

    const progressMap = {
      '1': 20,
      '2': 40,
      '3-female': 60,
      '3-male': 60,
      '4': 80,
      '5': 100
    };

    if (progressBar) {
      progressBar.style.width =
        (progressMap[stepName] || 20) + '%';
    }

    const card = popup.querySelector('.mm-popup__card');

    if (card) {
      card.scrollTop = 0;
    }
  }


  /* =========================================
     OPEN POPUP
     ========================================= */

  function openPopup() {

  // Check if user already closed/completed popup
  // Check if user already interacted with popup
if (
  localStorage.getItem('maa_popup_status')
) {
  return;
}

  if (popupOpened) return;

  popupOpened = true;

  popup.classList.add('is-open');
    popup.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.classList.add(
      'mm-popup-open'
    );

    showStep('1');

    trackEvent('popup_view');
  }


  /* =========================================
     CLOSE POPUP
     ========================================= */

  function closePopup() {

  popup.classList.remove('is-open');

  popup.setAttribute(
    'aria-hidden',
    'true'
  );

  document.body.classList.remove(
    'mm-popup-open'
  );


  // Remember user closed popup
 localStorage.setItem(
  'maa_popup_status',
  'closed'
);

}


  /* =========================================
     AUTOMATIC POPUP
     ========================================= */

  /*
   * Popup automatically appears
   * 5 seconds after page load.
   */

 setTimeout(function () {

  if (
    !localStorage.getItem('maa_popup_completed')
  ) {
    openPopup();
  }

}, 1000);

  /* =========================================
     TRACKING
     ========================================= */

  function trackEvent(eventName, data) {

    data = data || {};

    try {

      if (
        typeof window.dataLayer !==
        'undefined'
      ) {

        window.dataLayer.push({

          event: eventName,

          maa_mitahara: data

        });

      }

    } catch (error) {

      console.warn(
        'DataLayer tracking error:',
        error
      );

    }


    try {

      if (
        typeof window.gtag ===
        'function'
      ) {

        window.gtag(
          'event',
          eventName,
          data
        );

      }

    } catch (error) {

      console.warn(
        'GA tracking error:',
        error
      );

    }

  }


  /* =========================================
     ERROR HANDLING
     ========================================= */

  function showError(message) {

    const errorBox =
      popup.querySelector(
        '#mm-form-error'
      );

    if (!errorBox) return;

    errorBox.textContent = message;

    errorBox.hidden = false;
  }


  function hideError() {

    const errorBox =
      popup.querySelector(
        '#mm-form-error'
      );

    if (!errorBox) return;

    errorBox.hidden = true;

    errorBox.textContent = '';
  }


  /* =========================================
     FORM VALIDATION
     ========================================= */

  function validateContactForm() {

    hideError();

    const firstNameInput =
      popup.querySelector(
        '#mm-first-name'
      );

    const emailInput =
      popup.querySelector(
        '#mm-email'
      );

    const phoneInput =
      popup.querySelector(
        '#mm-phone'
      );


    const firstName =
      firstNameInput
        ? firstNameInput.value.trim()
        : '';

    const email =
      emailInput
        ? emailInput.value.trim()
        : '';

    const phone =
      phoneInput
        ? phoneInput.value.trim()
        : '';


    if (!firstName) {

      showError(
        'Please enter your first name.'
      );

      return false;
    }


    if (!email) {

      showError(
        'Please enter your email address.'
      );

      return false;
    }


    const emailPattern =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


    if (
      !emailPattern.test(email)
    ) {

      showError(
        'Please enter a valid email address.'
      );

      return false;
    }


    if (!phone) {

      showError(
        'Please enter your WhatsApp or phone number.'
      );

      return false;
    }


    /*
     * Basic Indian phone validation.
     */

    const phoneDigits =
      phone.replace(/\D/g, '');


    if (
      phoneDigits.length < 10
    ) {

      showError(
        'Please enter a valid phone number.'
      );

      return false;
    }


    return true;
  }


  /* =========================================
     MANUAL POPUP TRIGGER
     ========================================= */

  document.addEventListener(
    'click',
    function (event) {

      const trigger =
        event.target.closest(
          '[data-mm-open]'
        );


      if (!trigger) return;


      event.preventDefault();

      openPopup();

    }
  );


  /* =========================================
     CLOSE BUTTONS
     ========================================= */

  popup
    .querySelectorAll(
      '[data-mm-close]'
    )
    .forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          closePopup();

        }
      );

    });


  /* =========================================
     CLOSE WITH ESC
     ========================================= */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        popup.classList.contains(
          'is-open'
        )
      ) {

        closePopup();

      }

    }
  );


  /* =========================================
     STEP 1 → STEP 2
     ========================================= */

  const startButton =
    popup.querySelector(
      '[data-next="2"]'
    );


  if (startButton) {

    startButton.addEventListener(
      'click',
      function () {

        trackEvent(
          'quiz_started'
        );

        showStep('2');

      }
    );

  }


  /* =========================================
     GENDER SELECTION
     ========================================= */

  popup
    .querySelectorAll(
      '[data-gender]'
    )
    .forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          state.gender =
            button.dataset.gender;


          trackEvent(
            'gender_selected',
            {
              gender:
                state.gender
            }
          );


          /*
           * Female → trimester
           */

          if (
            state.gender ===
            'Female'
          ) {

            showStep(
              '3-female'
            );

          }

          /*
           * Male / other → shopping for
           */

          else {

            showStep(
              '3-male'
            );

          }

        }
      );

    });


  /* =========================================
     FEMALE → TRIMESTER
     ========================================= */

  popup
    .querySelectorAll(
      '[data-trimester]'
    )
    .forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          state.trimester =
            button.dataset.trimester;


          trackEvent(
            'trimester_selected',
            {
              trimester:
                state.trimester
            }
          );


          showStep('4');

        }
      );

    });


  /* =========================================
     MALE → SHOPPING FOR
     ========================================= */

  popup
    .querySelectorAll(
      '[data-shopping-for]'
    )
    .forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          state.shoppingFor =
            button.dataset.shoppingFor;


          trackEvent(
            'shopping_for_selected',
            {
              shopping_for:
                state.shoppingFor
            }
          );


          showStep('4');

        }
      );

    });


  /* =========================================
     BACK BUTTONS
     ========================================= */

  popup
    .querySelectorAll(
      '[data-back]'
    )
    .forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          const destination =
            button.dataset.back;


          showStep(
            destination
          );

        }
      );

    });


  /* =========================================
     CONTACT BACK BUTTON
     ========================================= */

  const contactBack =
    popup.querySelector(
      '#mm-contact-back'
    );


  if (contactBack) {

    contactBack.addEventListener(
      'click',
      function () {

        if (
          state.gender ===
          'Female'
        ) {

          showStep(
            '3-female'
          );

        } else {

          showStep(
            '3-male'
          );

        }

      }
    );

  }


  /* =========================================
     SUBMIT FORM
     ========================================= */

  const submitButton =
    popup.querySelector(
      '#mm-submit'
    );


  if (submitButton) {

    submitButton.addEventListener(
      'click',
      function () {

        /*
         * Validate
         */

        if (
          !validateContactForm()
        ) {

          return;

        }


        /*
         * Get contact details
         */

        const firstName =
          popup
            .querySelector(
              '#mm-first-name'
            )
            .value
            .trim();


        const email =
          popup
            .querySelector(
              '#mm-email'
            )
            .value
            .trim();


        const phone =
          popup
            .querySelector(
              '#mm-phone'
            )
            .value
            .trim();


        /*
         * Create lead object
         */

        const leadData = {

          first_name:
            firstName,

          email:
            email,

          phone:
            phone,

          gender:
            state.gender,

          trimester:
            state.trimester,

          shopping_for:
            state.shoppingFor

        };


        /*
         * Console for testing
         */

        console.log(
          'Maa Mitahara Lead:',
          leadData
        );


        /*
         * Tracking
         */

        trackEvent(
          'lead_submitted',
          leadData
        );


        /*
         * TEMPORARY STORAGE
         *
         * This is ONLY for testing.
         *
         * We will replace this with
         * Shopify customer submission.
         */

        /*
 * SEND LEAD TO GOOGLE SHEET
 */

fetch(
  "https://script.google.com/macros/s/AKfycbxPKkQUiUz4I1lrvAm1GZrol3DoXMH9Eeq-Mu04DYKp4dA60BHaQQjS_uNQe3v0FU-F/exec",
  {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({

      first_name: leadData.first_name,

      email: leadData.email,

      phone: leadData.phone,

      gender: leadData.gender,

      trimester: leadData.trimester,

      shopping_for: leadData.shopping_for,

      coupon: "MAAWELCOME12"

    })
  }
)
.then(function(){

  console.log(
    "Lead sent successfully"
  );

})
.catch(function(error){

  console.error(
    "Google Sheet Error:",
    error
  );

});


        /*
         * Show coupon
         */

        showStep('5');
// Remember user completed popup
localStorage.setItem(
  'maa_popup_status',
  'completed'
);


        trackEvent(
          'coupon_revealed',
          {
            coupon:
              'MAAWELCOME12'
          }
        );

      }
    );

  }


  /* =========================================
     SHOP NOW
     ========================================= */

  const shopNow =
    popup.querySelector(
      '#mm-shop-now'
    );


  if (shopNow) {

    shopNow.addEventListener(
      'click',
      function () {

        trackEvent(
          'coupon_clicked',
          {
            coupon:
              'MAAWELCOME12'
          }
        );


        /*
         * Shopify discount URL
         */

        window.location.href =
          '/discount/MAAWELCOME12';

      }
    );

  }


  /* =========================================
     EXPOSE FOR TESTING
     ========================================= */

  window.MaaMitaharaLeadPopup = {

    open:
      openPopup,

    close:
      closePopup,

    state:
      state

  };

})();